import {
  COMPANY_NAME_REGEX,
  EMAIL_REGEX,
  HAS_LETTER_REGEX,
  MAX_CONSECUTIVE_COMPANY_SPACES,
  NAME_REGEX,
  SAFE_TEXT_REGEX,
} from '@/utilities/constant'

/**
 * Merge class names; falsy values are omitted.
 */
export function cn(...classes: (string | undefined | false | null)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function hasRequiredLetter(value: string): boolean {
  return HAS_LETTER_REGEX.test(value)
}

export function isValidContactName(value: string): boolean {
  return NAME_REGEX.test(value)
}

export function sanitizeContactNameInput(value: string): string {
  return value.replace(/[^\p{Script=Latin}\p{Script=Arabic}\s'-]/gu, '')
}

export function isValidContactCompany(value: string): boolean {
  if (new RegExp(`\\s{${MAX_CONSECUTIVE_COMPANY_SPACES + 1},}`).test(value)) return false
  return COMPANY_NAME_REGEX.test(value) && hasRequiredLetter(value)
}

export function sanitizeContactCompanyInput(value: string): string {
  return value
    .replace(/[<>]/g, '')
    .replace(/[^\p{Script=Latin}\p{Script=Arabic}\d\s'.,&()/:@-]/gu, '')
    .replace(
      new RegExp(` {${MAX_CONSECUTIVE_COMPANY_SPACES + 1},}`, 'g'),
      ' '.repeat(MAX_CONSECUTIVE_COMPANY_SPACES),
    )
}

export function isValidContactText(value: string): boolean {
  return isValidContactCompany(value)
}

export function isValidContactMessage(value: string): boolean {
  return SAFE_TEXT_REGEX.test(value) && hasRequiredLetter(value)
}

export function isValidContactEmail(value: string): boolean {
  return EMAIL_REGEX.test(value) && hasRequiredLetter(value)
}
